import * as web3 from "@solana/web3.js"
import { BILLBOARD_PROGRAM_ID } from "../utils/constants";

export class User {
	publicKey: web3.PublicKey


	constructor(publicKey: web3.PublicKey) {
		this.publicKey = publicKey
	}

	static findAddres(authority: web3.PublicKey) {

		return web3.PublicKey.findProgramAddressSync(
			[Buffer.from("user"), authority.toBuffer()],
			new web3.PublicKey(BILLBOARD_PROGRAM_ID)
		);
	}

}